import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { clientSettings } from 'go-modules/models/common/client.settings';
import { Observable } from 'rxjs';
import type { Comment, CommentReaction } from '@go-modules/interfaces/comments/comment';

@Injectable({
	providedIn: 'root'
})
export class NgxCommentService {
	constructor (
		private http: HttpClient
	) {}

	public save (sessionId: number, payload): Observable<Comment> {
		return this.http.post<Comment>(
			`${clientSettings.GoReactV2API}/submissions/${sessionId}/comments`,
			payload
		);
	}

	public getForSession (sessionId: number): Observable<Comment[]> {
		return this.http.get<Comment[]>(`${clientSettings.GoReactV2API}/submissions/${sessionId}/comments`);
	}

	public addReaction (commentId: number|string, payload): Observable<CommentReaction> {
		return this.http.post<CommentReaction>(`${clientSettings.GoReactV2API}/comments/${commentId}/reactions`, payload);
	}

	public deleteReaction (commentId: number|string, reactionId: number): Observable<any> {
		return this.http.delete(`${clientSettings.GoReactV2API}/comments/${commentId}/reactions/${reactionId}`);
	}

	public getViewers (sessionId: number, commentId: number|string): Observable<any[]> {
		return this.http.get<any[]>(`${clientSettings.GoReactV2API}/submissions/${sessionId}/comments/${commentId}/views`);
	}

	public deleteComment (sessionId: number, commentId: number|string): Observable<any> {
		return this.http.delete(`${clientSettings.GoReactV2API}/submissions/${sessionId}/comments/${commentId}`);
	}

	public saveCommentViews (sessionId: number, commentIds: number[]): Observable<any> {
		return this.http.post(`${clientSettings.GoReactV2API}/sessions/${sessionId}/comment-views`, { commentIds });
	}
}
